var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';
import { ASAP } from '../../config';
import TimePicker from '../common/TimePicker';
import AlertIcon from 'Icons/Alert';
var deliveryTimeInputStyle = {
    width: 300,
    maxWidth: '100%',
};
var OrderFormDeliveryTime = function (props) {
    var onDeliveryTimeChange = props.onDeliveryTimeChange, onDeliveryAtChange = props.onDeliveryAtChange, isTakeout = props.isTakeout, minDeliveryTime = props.minDeliveryTime, value = props.value;
    var _a = __read(getMinOrderTime({
        hourNow: new Date().getHours(),
        minNow: new Date().getMinutes(),
        minDeliveryTime: minDeliveryTime,
    }), 1), minOrderHour = _a[0];
    return (React.createElement(FormGroup, { className: "col col-12 mt-3" },
        React.createElement(Label, null, "Zam\u00F3wienie na"),
        React.createElement(Input, { type: "select", name: "deliveryTime", onChange: function (e) {
                return onDeliveryTimeChange(e.target.value);
            }, value: value || '', style: deliveryTimeInputStyle },
            React.createElement("option", { value: ASAP }, "jak najszybciej"),
            React.createElement("option", { value: "other" }, "Inna godzina")),
        value !== ASAP && (React.createElement(React.Fragment, null,
            React.createElement(TimePicker, { className: "d-flex flex-row mw-300 mt-2", defaultHour: minOrderHour.toString(), minHour: minOrderHour, onChange: function (deliveryAt) { return onDeliveryAtChange(deliveryAt); } }),
            React.createElement("div", { className: "vertical-center mt-1" },
                React.createElement(AlertIcon, { style: {
                        color: 'var(--info)',
                        height: 20,
                        minWidth: 20,
                        marginRight: 8,
                    } }),
                React.createElement("span", null,
                    "Minimalne wyprzedzenie w wypadku zam\u00F3wienia z",
                    ' ',
                    isTakeout ? 'odbiorem osobistym' : 'dostawą',
                    ":",
                    ' ',
                    React.createElement("strong", null,
                        minDeliveryTime,
                        "min.")))))));
};
OrderFormDeliveryTime.propTypes = {
    onDeliveryTimeChange: PropTypes.func.isRequired,
    onDeliveryAtChange: PropTypes.func.isRequired,
    minDeliveryTime: PropTypes.number.isRequired,
    isTakeout: PropTypes.bool.isRequired,
    value: PropTypes.string,
};
function getMinOrderTime(params) {
    var hourNow = params.hourNow, minNow = params.minNow, minDeliveryTime = params.minDeliveryTime;
    var fullHours = Math.floor(minDeliveryTime / 60);
    var minsLeft = minDeliveryTime - fullHours * 60;
    if (minDeliveryTime <= 30) {
        return [hourNow + 1, 0];
    }
    return [hourNow + fullHours + Math.ceil((minsLeft + minNow) / 60), 0];
}
export default OrderFormDeliveryTime;
